export default "__VITE_ASSET___AGK5BJW__"